import { downloadReportFile } from "src/redux/admin/reporting/reporting.endpoints";

const handleReportDownload = async(platform: string, accountIds: number[], campaignIds: number[], startDate: string, endDate: string) => {

  const blob = await downloadReportFile({
    source: platform,
    account_ids: accountIds,
    campaign_ids: campaignIds,
    start_date: startDate,
    end_date: endDate,
  });

  //   if (!blob) {
  //     dispatch(showNotification({
  //       summary: "There is no data available for the selected criteria.",
  //       title: "No data available.",
  //       theme: "warning",
  //     }));
  //     return;
  //   }

  // Create a download link and trigger it
  if (blob) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `campaign-report-${platform}-${startDate}-${endDate}.csv`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }
  //   ErrorLogService.logError(error, 'campaign-reporter.page.tsx', 'handleDownload');
  //   dispatch(showNotification({
  //     summary: "Failed to download report. Please try again.",
  //     title: "Error",
  //     theme: "warning",
  //   }));
};

export default handleReportDownload;